<template>
  <div class="shop">
    <div class="top">
      <el-select
        style="width: 120px"
        size="small"
        v-model="form.keyword_type"
        filterable
        class="search"
        placeholder="搜索词类型"
      >
        <el-option label="红包商城" :value="1">红包商城</el-option>
        <el-option label="附近门店" :value="2">附近门店</el-option>
      </el-select>

      <el-button
        class="search"
        size="small"
        type="primary"
        @click="searchOrderData"
        >搜索</el-button
      >
      <el-button
        class="add-word"
        size="mini"
        type="primary"
        @click="showSearchModal"
        >新增关键词</el-button
      >
    </div>

    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="序号" prop="id"></el-table-column>
      <el-table-column label="关键词">
        <template slot-scope="scope">
          {{ scope.row.key_word }}
        </template>
      </el-table-column>
      <el-table-column label="是否推荐">
        <template slot-scope="scope">
          {{ scope.row.is_red === 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label="当前状态">
        <template slot-scope="scope">
          {{ scope.row.is_delete === 1 ? '展示' : '隐藏' }}
        </template>
      </el-table-column>
      <el-table-column label="排序">
        <template slot-scope="scope">
          {{ scope.row.sort }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="
              editSearchword(
                scope.row.id,
                scope.row.key_word,
                scope.row.sort,
                scope.row.is_red,
                scope.row.keyword_type
              )
            "
            >编辑</el-button
          >
          <el-button
            size="mini"
            :type="scope.row.is_delete === 1 ? '' : 'primary'"
            @click="switchSearchword(scope.row.is_delete, scope.row.id)"
            >{{
              scope.row.is_delete === 1 ? '点击隐藏' : '点击显示'
            }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
    <!-- 关键词添加编辑 -->
    <jdialog title="推荐关键词配置" :visible.sync="showSwitch" width="400px">
      <el-form
        :model="pushform"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="关键词:">
          <el-input
            maxlength="32"
            v-model="pushform.key_word"
            placeholder="请输入关键词"
            size="mini"
            style="width: 220px"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序:">
          <el-input
            maxlength="64"
            v-model="pushform.sort"
            placeholder="请输入排序数字"
            size="mini"
            style="width: 220px"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否推荐:">
          <el-radio v-model="pushform.is_red" :label="1">是</el-radio>
          <el-radio v-model="pushform.is_red" :label="2">否</el-radio>
        </el-form-item>
        <el-form-item label="搜索词类型:">
          <el-select
            style="width: 120px"
            size="small"
            v-model="pushform.keyword_type"
            filterable
            class="search"
            placeholder="搜索词类型"
          >
            <el-option label="红包商城" :value="1">红包商城</el-option>
            <el-option label="附近门店" :value="2">附近门店</el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="text-align: center; margin-right: 120px">
          <el-button type="primary" size="mini" @click="addSearchword"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </jdialog>
  </div>
</template>

<script>
// import uploadImg from "@/components/uploadImg";
import { setSearchword, addSearchword, switchSearchword } from '@/api/autarky'
// import {
//   createBanner,
//   getNewBannerList,
//   updateBanner,
//   deleteBanner
// } from '@/api/setting'
export default {
  components: {},
  data() {
    return {
      tableData: [],
      showSwitch: false,
      form: {
        cate_id: '',
        cate_name: '',
        page: 1,
        size: 20,
        keyword_type: '',
      },
      total: 0,
      pushform: {
        id: '',
        key_word: '',
        sort: '',
        is_red: 1,
        keyword_type: '',
      },
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    //获取列表数据
    async getListData() {
      var url =
        'page=' + this.form.page + '&keyword_type=' + this.form.keyword_type
      let res = await setSearchword(url)
      if (res.code === 10000) {
        this.tableData = res.data.data
        this.total = res.data.total
      } else {
        this.$message.error(res.message)
      }
    },
    //新增&&编辑关键词
    showSearchModal() {
      this.pushform = {
        id: '',
        key_word: '',
        sort: '',
        is_red: 1,
      }
      this.showSwitch = true
    },

    searchOrderData() {
      this.getListData()
    },

    editSearchword(id, key_word, sort, is_red, keyword_type) {
      this.pushform = {
        id: id,
        key_word: key_word,
        sort: sort,
        is_red: is_red,
        keyword_type,
      }
      this.showSwitch = true
    },

    async addSearchword() {
      let pushform = this.pushform
      let res = await addSearchword(pushform)
      if (res.code === 10000) {
        this.getListData()
        this.showSwitch = false
      } else {
        this.$message.error(res.message)
      }
    },

    // 隐藏显示
    async switchSearchword(showtype, id) {
      let data = {
        is_delete: showtype == 1 ? 2 : 1,
        id: id,
      }
      let res = await switchSearchword(data)
      if (res.code === 10000) {
        this.getListData()
      } else {
        this.$message.error(res.message)
      }
    },

    // 分页设置
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getListData()
    },
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    },
  },
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
  .add-word {
    float: right;
    margin-bottom: 10px;
  }
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .search {
    margin-right: 10px;
  }
}
</style>
